// Shared clinician display name (mirrors the backend's src/utils/clinicianName.js).
// MD, DO, APRN: "First M. Last, MD" ("First Last, MD" without a middle name). Everyone else: "First Last".
// Never adds a "Clin." / "Dr." prefix. `credential` wins over the legacy `title` (MD|APRN) field.
export const CREDENTIALS = ['MD', 'DO', 'APRN', 'PA', 'RN', 'LPN', 'MA', 'Other'];
export const SUFFIXED_CREDENTIALS = ['MD', 'DO', 'APRN'];

const clean = (v) => String(v === null || v === undefined ? '' : v).replace(/\s+/g, ' ').trim();

export const credentialOf = (p) => clean(p && (p.credential || p.title)).toUpperCase().replace(/\./g, '');

export const middleInitial = (middleName) => {
  const m = clean(middleName);
  return m ? `${m[0].toUpperCase()}.` : '';
};

export const formatClinicianName = (p, fallback = '') => {
  if (!p || typeof p !== 'object') return fallback;
  const first = clean(p.firstname);
  const last = clean(p.lastname);
  const credential = credentialOf(p);
  if (SUFFIXED_CREDENTIALS.includes(credential) && (first || last)) {
    return `${[first, middleInitial(p.middleName), last].filter(Boolean).join(' ')}, ${credential}`;
  }
  return [first, last].filter(Boolean).join(' ') || clean(p.name) || fallback;
};

export default formatClinicianName;
